import { render, staticRenderFns } from "./CommentsFromProduct.vue?vue&type=template&id=5ac264db&"
import script from "./CommentsFromProduct.vue?vue&type=script&lang=js&"
export * from "./CommentsFromProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports